import { Injectable } from '@angular/core';

import { PriceMapper } from 'ish-core/models/price/price.mapper';

import { SaveForLaterData } from './save-for-later.interface';
import { SaveForLater } from './save-for-later.model';

@Injectable({ providedIn: 'root' })
export class SaveForLaterMapper {
  fromData(saveForLaterData: SaveForLaterData): SaveForLater {
    if (saveForLaterData) {
      return {
        wishlistId: saveForLaterData.wishlistId,
        lineItems: saveForLaterData.lineItems.map(item => ({
          wishlistLineItemId: item.wishlistLineItemId,
          desiredQuantity: item.desiredQuantity,
          price: PriceMapper.fromData(item.price),
          totalPrice: PriceMapper.fromData(item.totalPrice),
          sku: item.sku,
        })),
      };
    } else {
      throw new Error(`saveForLaterData is required`);
    }
  }
}
